import React from 'react';
import './IOSAppDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Swift & Objective-C Expertise",
    "Native Performance & UI/UX",
    "App Store Deployment Support",
    "iPad & iPhone Compatibility",
    "Third-Party API Integration",
    "Push Notifications & In-App Purchases",
    "Offline Functionality & Data Sync",
    "Advanced Testing & QA Processes"
];

const benefits = [
    "Secure & High-Performance Apps",
    "End-to-End App Development",
    "Scalable Architecture",
    "Post-launch Maintenance & Support",
    "Custom Design Tailored to Brand",
    "Full App Store Compliance",
    "Faster Time to Market",
    "Dedicated Project Manager"
];

const industries = [
    "Healthcare",
    "eCommerce",
    "Finance",
    "Education",
    "Travel & Hospitality",
    "Fitness & Lifestyle",
    "Logistics & Delivery",
    "Media & Entertainment"
];

const IOSAppDevelopment = () => {
    return (
        <div className="ios-container">
            <Helmet>
  <title>iOS App Development Services | APTech Solution</title>
  <meta 
    name="description" 
    content="APTech Solution develops high-quality iOS mobile apps with modern UI/UX, robust functionality, and App Store deployment support." 
  />
</Helmet>

            <h1 className="ios-title">iOS App Development</h1>
            <p className="ios-subtitle">
                We build secure, high-performing iOS apps tailored to your business needs — delivering seamless user experiences across iPhone and iPad.
            </p>

            <section className="ios-section">
                <h2 className="section-heading">Why Build an iOS App?</h2>
                <p className="ios-paragraph">
                    iOS apps are known for their superior performance, enhanced security, and loyal user base. With Apple's tightly controlled ecosystem, iOS provides a stable and secure platform for high-quality applications that drive engagement and ROI.
                </p>
            </section>

            <section className="ios-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">📱</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="ios-section">
                <h2 className="section-heading">Industries We Serve</h2>
                <div className="card-grid">
                    {industries.map((industry, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🏢</span>
                            <p>{industry}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="ios-section">
                <h2 className="section-heading">Benefits of Partnering with Us</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Let's Build Your iOS App</h3>
                <p>Have an app idea? We'll help you bring it to life — from concept to App Store launch.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Your Project</button>
                </a>
               
            </section>
        </div>
    );
};

export default IOSAppDevelopment;
